import { Box, Card, Grid, TextField, Button, MenuItem } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { apiput } from '../../service/api';
import { SectionCard, SectionHeader, FieldRow } from '../Lead/LeadViewStyles';

const CONTACT_TYPES = [
  'Call',
  'Email',
  'SMS',
  'Voicemail',
  'Meeting',
  'In-Person',
  'Other',
];

const CONTACT_RESULTS = [
  'Answered',
  'No Answer',
  'Left Voicemail',
  'Callback Requested',
  'Interested',
  'Not Interested',
  'Wrong Number',
  'Do Not Call',
  'Scheduled Follow-up',
];

const YES_NO = ['Yes', 'No'];

const dateFieldProps = {
  type: 'date',
  InputLabelProps: { shrink: true },
};

const BankrateLeadTracking = ({ data, setUserAction }) => {
  const [formData, setFormData] = useState({ ...data });
  const [isEdited, setIsEdited] = useState(false);

  useEffect(() => {
    setFormData({ ...data });
    setIsEdited(false);
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setIsEdited(true);
  };

  const handleSave = async () => {
    const payload = {
      leadAssignedTo: formData.leadAssignedTo || '',
      lassoRecordNumber: formData.lassoRecordNumber || '',
      leadStatus: formData.leadStatus || '',
      contactDate1: formData.contactDate1 || '',
      contactResults1: formData.contactResults1 || '',
      contactType1: formData.contactType1 || '',
      contactDate2: formData.contactDate2 || '',
      contactResults2: formData.contactResults2 || '',
      contactType2: formData.contactType2 || '',
      contactDate3: formData.contactDate3 || '',
      contactResults3: formData.contactResults3 || '',
      contactType3: formData.contactType3 || '',
      preApproved: formData.preApproved || '',
      refiOfferAccepted: formData.refiOfferAccepted || '',
      assignCampaign: formData.assignCampaign || '',
      campaignLastSentDate: formData.campaignLastSentDate || '',
      optIn: formData.optIn || '',
      subscribed: formData.subscribed || '',
      helpfulInfo: formData.helpfulInfo || '',
    };
    const result = await apiput(`bankrate-lead/edit/${data._id}`, payload);
    if (setUserAction) setUserAction(result);
    if (result?.status === 200) {
      toast.success('Lead tracking updated successfully!');
      setIsEdited(false);
    } else {
      toast.error('Failed to update lead tracking.');
    }
  };

  return (
    <div>
      <Card style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px' }}>
        <Box p={3}>
          {/* Lead Assignment */}
          <SectionCard>
            <SectionHeader>Lead Assignment</SectionHeader>
            <FieldRow>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Lead Assigned To"
                  name="leadAssignedTo"
                  value={formData.leadAssignedTo || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="LASSO Record #"
                  name="lassoRecordNumber"
                  value={formData.lassoRecordNumber || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Lead Status"
                  name="leadStatus"
                  value={formData.leadStatus || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="Call 1 - Not Interested">Call 1 - Not Interested</MenuItem>
                  <MenuItem value="Call 1 - No Answer">Call 1 - No Answer</MenuItem>
                  <MenuItem value="Call 1 - Left Message">Call 1 - Left Message</MenuItem>
                  <MenuItem value="Call 2 - Not Interested">Call 2 - Not Interested</MenuItem>
                  <MenuItem value="Call 2 - No Answer">Call 2 - No Answer</MenuItem>
                  <MenuItem value="Call 2 - Left Message">Call 2 - Left Message</MenuItem>
                  <MenuItem value="Application Pending">Application Pending</MenuItem>
                  <MenuItem value="Application Received">Application Received</MenuItem>
                  <MenuItem value="Pre-Approved - Active Shop...">Pre-Approved - Active Shop...</MenuItem>
                  <MenuItem value="Pre-Approved - Under Contr...">Pre-Approved - Under Contr...</MenuItem>
                  <MenuItem value="Dead Lead">Dead Lead</MenuItem>
                  <MenuItem value="Not Interested">Not Interested</MenuItem>
                  <MenuItem value="Campaign - FHA Streamline ...">Campaign - FHA Streamline ...</MenuItem>
                  <MenuItem value="Campaign - VA IRRRL Alert">Campaign - VA IRRRL Alert</MenuItem>
                  <MenuItem value="Campaign - Monthly Touchbase">Campaign - Monthly Touchbase</MenuItem>
                  <MenuItem value="Campaign - Quarterly Check...">Campaign - Quarterly Check...</MenuItem>
                  <MenuItem value="New">New</MenuItem>
                  <MenuItem value="Contacted">Contacted</MenuItem>
                  <MenuItem value="Qualified">Qualified</MenuItem>
                  <MenuItem value="Not Qualified">Not Qualified</MenuItem>
                  <MenuItem value="Closed/Won">Closed/Won</MenuItem>
                  <MenuItem value="Closed/Lost">Closed/Lost</MenuItem>
                  <MenuItem value="Follow-up Required">Follow-up Required</MenuItem>
                  <MenuItem value="On Hold">On Hold</MenuItem>
                  <MenuItem value="Converted">Converted</MenuItem>
                  <MenuItem value="Credit Repair">Credit Repair</MenuItem>
                </TextField>
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Contact Attempts */}
          <SectionCard>
            <SectionHeader>Contact Attempts</SectionHeader>
            {[1, 2, 3].map((n) => (
              <FieldRow key={n} sx={{ mb: n < 3 ? 1 : 0 }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label={`Contact Date ${n}`}
                    name={`contactDate${n}`}
                    value={formData[`contactDate${n}`] || ''}
                    fullWidth
                    margin="dense"
                    onChange={handleChange}
                    {...dateFieldProps}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label={`Contact ${n} Results`}
                    name={`contactResults${n}`}
                    value={formData[`contactResults${n}`] || ''}
                    fullWidth
                    margin="dense"
                    onChange={handleChange}
                    select
                  >
                    <MenuItem value="">—</MenuItem>
                    {CONTACT_RESULTS.map((r) => (
                      <MenuItem key={r} value={r}>{r}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label={`Contact ${n} Type`}
                    name={`contactType${n}`}
                    value={formData[`contactType${n}`] || ''}
                    fullWidth
                    margin="dense"
                    onChange={handleChange}
                    select
                  >
                    <MenuItem value="">—</MenuItem>
                    {CONTACT_TYPES.map((t) => (
                      <MenuItem key={t} value={t}>{t}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </FieldRow>
            ))}
          </SectionCard>

          {/* Action Taken */}
          <SectionCard>
            <SectionHeader>Action Taken</SectionHeader>
            <FieldRow>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Preapproved?"
                  name="preApproved"
                  value={formData.preApproved || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Refi Offer Accepted?"
                  name="refiOfferAccepted"
                  value={formData.refiOfferAccepted || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Assign Campaign"
                  name="assignCampaign"
                  value={formData.assignCampaign || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Campaign Last Sent Date"
                  name="campaignLastSentDate"
                  value={formData.campaignLastSentDate || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  {...dateFieldProps}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Authorization */}
          <SectionCard>
            <SectionHeader>Authorization</SectionHeader>
            <FieldRow>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Opt-In?"
                  name="optIn"
                  value={formData.optIn || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="">—</MenuItem>
                  {YES_NO.map((v) => (
                    <MenuItem key={v} value={v}>{v}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Subscribed?"
                  name="subscribed"
                  value={formData.subscribed || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                  select
                >
                  <MenuItem value="">—</MenuItem>
                  {YES_NO.map((v) => (
                    <MenuItem key={v} value={v}>{v}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Notes */}
          <SectionCard>
            <SectionHeader>Notes</SectionHeader>
            <TextField
              label="Helpful Information"
              name="helpfulInfo"
              value={formData.helpfulInfo || ''}
              fullWidth
              margin="dense"
              multiline
              rows={4}
              onChange={handleChange}
            />
          </SectionCard>

          {/* Save Button */}
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={!isEdited}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Card>
    </div>
  );
};

export default BankrateLeadTracking;
